// extracted by mini-css-extract-plugin
export var baseButton = "_pd-0";
export var controlsArrowKeys = "_pd-1";
export var controlsResetButton = "_pd-2";
export var lightGameButton = "_pd-4 _pd-0";
export var playAgainButton = "_pd-5 _pd-0";
export var startGameButton = "_pd-3 _pd-0";